import React, { useContext, useCallback, useEffect, useRef } from 'react';

import { DateRangeDropdown } from '../../../../../../../components/date-range-dropdown';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import options from '../../../../../../../components/date-range-dropdown/date-range-options';
import { ReportsContext } from '../../../context';
import { PARAMETER_NAME_INVOICE_ID } from '../../report-parameter-names';
import style from '../../style.module.less';
import { labelsMessages } from '../../messages';
import { FormattedMessage } from 'react-intl';
import { calculateTargetDatetimesFromOperator } from '../../../../../../../components/date-range-dropdown/calculate-date-range-helper';
import { useSelector } from 'react-redux';
import Global from '../../../../../../../store/global-selectors';

const BillingDateRange = () => {
  const { setDateRange, startDate, endDate, params } = useContext(ReportsContext);
  const hasInvoiceId = Boolean(params[PARAMETER_NAME_INVOICE_ID]?.trim());
  const sellerTimeZone = useSelector(Global.selectSellerTimeZoneIANA);
  const hasInitialized = useRef(false);

  useEffect(() => {
    const shouldInitDefaultRange = !hasInitialized.current && !hasInvoiceId && (!startDate || !endDate);
    if (shouldInitDefaultRange) {
      const lastMonthRange = calculateTargetDatetimesFromOperator('dateLastMonth', sellerTimeZone);
      setDateRange({
        startRangeDate: lastMonthRange.startDate,
        endRangeDate: lastMonthRange.endDate,
      });
      hasInitialized.current = true;
    }
  }, [hasInvoiceId, startDate, endDate, sellerTimeZone, setDateRange]);

  const handleDateRangeUpdated = useCallback(
    ({ startDate: newStartDate, endDate: newEndDate }) => {
      setDateRange({ startRangeDate: newStartDate, endRangeDate: newEndDate });
    },
    [setDateRange],
  );
  if (hasInvoiceId) {
    return (
      <DropdownMenuToggler className={style['dropdown-toggler']} disabled theme='white'>
        <FormattedMessage {...labelsMessages.dateRangeDisabled} />
      </DropdownMenuToggler>
    );
  }
  return (
    <DateRangeDropdown
      dateRangeOptions={options}
      dropdownTogglerClassname={style['dropdown-toggler']}
      endDate={endDate}
      initialOption='dateLastMonth'
      onDateRangeUpdated={handleDateRangeUpdated}
      startDate={startDate}
    />
  );
};

export default BillingDateRange;
